import { Stack } from '@mui/material'
import { purple, red, blue, teal, lightGreen, yellow, orange } from '@mui/material/colors'
import {
    Radar,
    RadarChart,
    PolarGrid,
    PolarAngleAxis,
    PolarRadiusAxis,
    ResponsiveContainer,
    Legend,
    Line,
} from 'recharts'
import { usePRRadarChart } from 'hooks/pranalysis'
import { useAtomValue } from 'jotai'
import { typeAtom } from './atoms'


const colorList = [
    purple[300],
    blue[300],
    teal[300],
    lightGreen[300],
    yellow[300],
    orange[300],
    red[300]
]

const PRRadarChart = ({ targetPrIndex }) => {
    const type = useAtomValue(typeAtom)
    const { data } = usePRRadarChart(type, targetPrIndex)

    if (!data) return null

    const repeatedColorList = Array.from({ length: data.pranalysis.length }, (_, i) => colorList[i % colorList.length])

    return (<>
        {data.pranalysis.length === 0 &&
        <Stack
            sx={{
                position: "absolute",
                width: "100%",
                height: "100%",
                bgcolor: "#ccc",
                opacity: 0.7,
                alignItems: "center",
                justifyContent: "center",
                fontSize: 30,
                fontWeight: 700,
                color: "#000",
                zIndex: 1000,
            }}
        >
            2025年5月以降の診断から表示されます
        </Stack>
        }
        <ResponsiveContainer
            height={600}
        >
            <RadarChart
                data=
                {data.titles.map(t => {
                    const result = {}
                    result.subject = `${t.num}. ${t.title}`
                    data.pranalysis.forEach((p, i) => result[`score${i+1}`] = p[t.title]?.合計点数 || 0)
                    return result
                })}
                cx="50%"
            >
                <PolarGrid />
                <PolarAngleAxis 
                    dataKey="subject" 
                />
                <PolarRadiusAxis 
                    domain={[0, data.domain]}
                />

                {[...repeatedColorList]
                    .map((c, i, a) => 
                        <Radar 
                            key={i}
                            name={`${data.pranalysis[i]?.診断回}回目`}
                            dataKey={`score${i + 1}`}
                            stroke={i !== a.length-1 ? c : red[300]}
                            fill={i !== a.length-1 ?  c :  red[300]}
                            fillOpacity={0.1}
                            legendType="rect"
                            dot={i === a.length-1}
                            strokeWidth={i !== a.length-1 ? 1 : 2} 
                            type="basisOpen"
                        />
                    )
                }
                <Line 
                    type="step" 
                    dataKey="score7" 
                    stroke="#ff0092" 
                    strokeWidth={2} 
                />
                <Legend />
            </RadarChart>
        </ResponsiveContainer>
    </>)
}

export default PRRadarChart
